import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClose(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClose() {
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
